export   const isLightMode = () => {
    if (localStorage.getItem("mode") === null) {
      return true;
    }
    if (JSON.parse(localStorage.getItem("mode"))) {
      return true;
    }
    return false;
  }